var internet = {};
module['exports'] = internet;
internet.domain_suffix = require("./domain_suffix");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_IE/internet/index.js
 ** module id = 414
 ** module chunks = 0
 **/